import { createTheme } from '@mui/material/styles';

import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/700.css';

const theme = createTheme({
    typography: {
        fontFamily: [
            'Inter', // Primary font
            'Roboto', // Fallback for Material UI components
            'sans-serif',
        ].join(','),
        button: {
            textTransform: 'none', // This disables the default uppercase
        },
    },
    palette: {
        primary: {
            main: "#6769DF",//#5E17EB
            dark: "#4b4fc1",
            dark2: "#5E17EB",
            light1: "#9394f0",
            contrastText: '#FFF',
            disabledInput:"rgba(0,0,0,0.04)"
        },
        secondary: {
            main: "#14c4b4",
            dark: "#0e8e84",
            contrastText: '#fff'
        },
        tertiary:{
            main: "#800080",
            contrastText: '#fff'
        }
    }
})
export default theme;